import { apiRequest } from "../util/apiUtils";

export const organizationReviewList = async (params) => {
  try {
    const res = await apiRequest("get", `/review/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationReviewDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `review/delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationReviewAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `review/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const organizationReviewStatusUpdate = async (payload) => {
  try {
    const res = await apiRequest("patch", `review/status`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
